export default "__VITE_ASSET__B_jk0iKn__"